import { useRequiredContext } from "@redotech/react-util/context";
import PickupTruckIcon from "@redotech/redo-icons/truck-01.svg";
import PickupTruckFilledIcon from "@redotech/redo-icons/truck-01_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { TeamType } from "@redotech/redo-model/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import {
  ORDERS_ICON,
  ORDERS_ICON_FILLED,
  OrderManagementSuiteStatusesContext,
} from "../../../../redo-suite/order-management-cloud";

export const OrdersItem = memo(function OrdersItem() {
  const team = useRequiredContext(TeamContext);
  const routes = useRequiredContext(MerchantRoutesContext);
  const { omsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const canViewAllOrdersTab = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER,
  );

  const showAllOrders =
    team.teamType !== TeamType.FulfillmentService && canViewAllOrdersTab;

  if (!showAllOrders) {
    return null;
  }

  // When OMS is not enabled, show legacy navigation items
  if (!omsEnabled) {
    return (
      <>
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getOrdersOutboundLabelsSubRoute("orders"),
          }}
          FilledIcon={ORDERS_ICON_FILLED}
          friendlyName="All orders"
          id="all-orders"
          UnfilledIcon={ORDERS_ICON}
        />
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getOrdersOutboundLabelsSubRoute("about"),
          }}
          FilledIcon={PickupTruckFilledIcon}
          friendlyName="Shipments"
          id="about-oms"
          isNew
          UnfilledIcon={PickupTruckIcon}
        />
      </>
    );
  }

  // When OMS is enabled, Orders is a simple link to All Orders
  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getOrdersOutboundLabelsSubRoute("orders"),
      }}
      FilledIcon={ORDERS_ICON_FILLED}
      friendlyName="Orders"
      id="orders"
      UnfilledIcon={ORDERS_ICON}
    />
  );
});
